// hooks/useCart.js
import { useState, useEffect, createContext, useContext } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // Başlangıçta localStorage'da sepet var mı diye bakıyoruz
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('myAppCart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Sepet her değiştiğinde localStorage'ı güncelliyoruz
  useEffect(() => {
    localStorage.setItem('myAppCart', JSON.stringify(cart));
  }, [cart]);

  // Sepete Ekleme
  const addToCart = (product) => {
    // Zaten sepette var mı kontrolü (Abonelik için 1 adet yeterli olabilir ama genel mantık)
    const exists = cart.find((item) => item.id === product.id);
    if (exists) {
      alert('Bu paket zaten sepetinizde!');
      return;
    }
    setCart([...cart, product]);
    // alert('Ürün sepete eklendi!'); // İsteğe bağlı, UI'da toast vs. daha iyi olur
  };

  // Sepetten Çıkarma
  const removeFromCart = (productId) => {
    setCart(cart.filter((item) => item.id !== productId));
  };

  // Sepeti Temizleme
  const clearCart = () => {
    setCart([]);
  };

  // Toplam Tutar Hesaplama
  const cartTotal = cart.reduce((total, item) => total + (Number(item.price) || 0), 0);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, cartTotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);